const DISCOUNT_RATE_MAX = 100
/**
 * Discount rate 若為 5 -> 95 折,
 * Discount rate 若為 10 -> 9 折
 */
export const getDiscountPercentage = (discountRate: number) => {
  const discountValue = DISCOUNT_RATE_MAX - discountRate
  // 如果能被 10 整除，顯示為「折數」(如 90 -> 9)，否則顯示原始數字 (如 95 -> 95)
  if (discountValue % 10 === 0) {
    return discountValue / 10
  }
  else {
    return discountValue
  }
}

/**
 * 將台灣習慣的「折數」轉換成英文的「折扣率」
 * @param discountPercentage 折數（1-100 範圍，例如: 95 折, 90 折, 67 折）
 * @returns discountRate 折扣率百分比 (例如: 5, 10, 33)
 *
 * @example
 * getDiscountRate(95) // 5 (代表 5% off)
 * getDiscountRate(90) // 10 (代表 10% off)
 * getDiscountRate(67) // 33 (代表 33% off)
 */
export const getDiscountRate = (discountPercentage: number | null): number | null => {
  if (discountPercentage === null) return null
  return Math.round(100 - discountPercentage)
}
